import { useState, useEffect, useCallback } from 'react';
import stationUptimeService from 'src/services/stationUptimeService';

const useStationUptime = (teamId, timeRange = '30d') => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!teamId) return;
    
    try {
      setIsLoading(true);
      setError(null);
      
      const response = await stationUptimeService.getStationUptime(teamId, {
        timeRange,
        includeDetails: true,
        statusFilter: 'all'
      });
      
      // Response is now direct data from the service (following project pattern)
      setData(response.data);
    } catch (err) {
      console.error('❌ Error fetching station uptime data:', err);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [teamId, timeRange]);

  const getStationDetails = useCallback(async (stationId) => {
    if (!teamId || !stationId) return null;
    
    try {
      const response = await stationUptimeService.getStationUptimeDetails(teamId, stationId, {
        timeRange
      });
      
      // Response is now direct data from the service (following project pattern)
      return response.data;
    } catch (err) {
      console.error('Error fetching station details:', err);
      throw err;
    }
  }, [teamId, timeRange]);

  // Clear data when timeRange changes to show loading state
  useEffect(() => {
    setData(null);
  }, [timeRange]);

  // Fetch data on mount and when dependencies change
  useEffect(() => {
    if (teamId) {
      refresh();
    }
  }, [teamId, timeRange, refresh]);

  return {
    data,
    isLoading,
    error,
    refresh,
    getStationDetails
  };
};

export default useStationUptime;
